module.exports = __webpack_public_path__ + "img/yanfei.e8d5aca4.webp";